import { useState } from "react";
import axios from "axios";
import { Phone, MessageCircle, Send, CalendarClock } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const OWNER_WHATSAPP = "918000003086";
const STATUSES = ["New", "Contacted", "In Progress", "Completed", "Closed"];

const waNumber = (phone) => { const d = (phone || "").replace(/\D/g, ""); return d.length === 10 ? `91${d}` : d; };
const today = () => new Date().toLocaleDateString("en-CA");

const summary = (x) => `New Plan Pass Inquiry\nName: ${x.name}\nPhone: ${x.phone}\nEmail: ${x.email || "-"}\nCity: ${x.city}\nRequirement: ${x.service}\nMessage: ${x.message || "-"}`;

function DueBadge({ date, status, id }) {
  if (!date || ["Completed", "Closed"].includes(status)) return null;
  const t = today();
  const label = date < t ? "Overdue" : date === t ? "Due today" : `Follow-up ${date}`;
  const cls = date < t ? "overdue" : date === t ? "due" : "upcoming";
  return <em className={`due-badge ${cls}`} data-testid={`followup-badge-${id}`}>{label}</em>;
}

export const InquiryRow = ({ x, onStatus, onSaved }) => {
  const [date, setDate] = useState(x.followup_date || "");
  const [note, setNote] = useState(x.followup_note || "");
  const [saved, setSaved] = useState(false);
  const save = async () => {
    const body = { followup_date: date || null, followup_note: note };
    await axios.patch(`${API}/inquiries/${x.id}/followup`, body, { withCredentials: true });
    onSaved(body); setSaved(true); setTimeout(() => setSaved(false), 1800);
  };
  const customerMsg = encodeURIComponent(`Hello ${x.name}, thank you for contacting Mehta Associates regarding ${x.service}.`);
  return (
    <article className="inquiry-row" data-testid={`inquiry-row-${x.id}`}>
      <div>
        <b>{x.name} <DueBadge date={x.followup_date} status={x.status} id={x.id} /></b>
        <span>{x.phone} · {x.city}{x.email ? ` · ${x.email}` : ""}</span>
        <p>{x.service} — {x.message || "No additional message"}</p>
        <div className="followup">
          <CalendarClock size={15} />
          <input type="date" value={date} onChange={(e) => setDate(e.target.value)} data-testid={`followup-date-${x.id}`} />
          <input placeholder="Follow-up note" value={note} onChange={(e) => setNote(e.target.value)} data-testid={`followup-note-${x.id}`} />
          <button onClick={save} data-testid={`followup-save-${x.id}`}>{saved ? "Saved" : "Save"}</button>
        </div>
      </div>
      <div className="row-actions">
        <a href={`tel:${x.phone}`} data-testid={`call-inquiry-${x.id}`}><Phone size={15} /> Call</a>
        <a href={`https://wa.me/${waNumber(x.phone)}?text=${customerMsg}`} target="_blank" rel="noreferrer" data-testid={`whatsapp-customer-${x.id}`}><MessageCircle size={15} /> WhatsApp</a>
        <a href={`https://wa.me/${OWNER_WHATSAPP}?text=${encodeURIComponent(summary(x))}`} target="_blank" rel="noreferrer" data-testid={`whatsapp-self-${x.id}`}><Send size={15} /> Send to my WhatsApp</a>
        <select value={x.status} onChange={(e) => onStatus(x.id, e.target.value)} data-testid={`status-inquiry-${x.id}`}>{STATUSES.map((s) => <option key={s}>{s}</option>)}</select>
      </div>
    </article>
  );
};
